import { RedoitTheme } from "../../theme"
import { createFlex } from "../../../../../../packages/web-ui/components/base/Flex"
import { ComponentProps } from "react"

export const Flex = createFlex<RedoitTheme>()

export type FlexProps = ComponentProps<typeof Flex>
